// extracted by mini-css-extract-plugin
export default {"root":"footer_root__qKiEJ","ul-wrapper":"footer_ul-wrapper__PC7Jc","logo-wrapper":"footer_logo-wrapper__qWxV8","nowrap":"footer_nowrap__-eCng"};